import React, { useEffect, useState } from "react";
import classes from "./Section.module.css";
import { useNavigate, useParams } from "react-router-dom";
import CheckIcon from "@mui/icons-material/Check";
import FormGroup from "@mui/material/FormGroup";
import Button from '@mui/material/Button';
import FormControlLabel from "@mui/material/FormControlLabel";
import Switch from "@mui/material/Switch";
// Toggle Button

const Section = ({ users, data }) => {
  const { implId, id } = useParams();
  const [stageData, setStageData] = useState(true);
  const [show_alt_name, setshow_alt_name] = useState(false);
  const [itemsToShow, setItemsToShow] = useState({});

  console.log("section data ", data, users);

  

  const handlealt_name = () => {
    setshow_alt_name(!show_alt_name);
  };
  const newStages = data.sort((a, b) => a.order - b.order);

  const collectAndSplitDataByStages = (stages) => {
    const result = {};
    if (show_alt_name) {
      stages.forEach((stage) => {
        result[stage] = users.filter((dataItem) => dataItem.stage === stage);
      });
      return result;
    } else {
      stages.forEach((stage) => {
        result[stage] = users.filter((dataItem) => dataItem.alt_name === stage);
      });
      return result;
    }
  };

  // Example: Collect and split Marketing and Sales related objects
  const selectedStages = newStages.map((e) =>
    show_alt_name ? e.stage : e.alt_name
  );
  
  const collectedData = collectAndSplitDataByStages(selectedStages);

  const arrayOfData = Object.entries(collectedData).map(([key, value]) => ({
    key,
    value,
  }));

  // REMOVING THE REPEATED DATA BASED ON THE STATUS
  const removeDuplicates = (arrayOfObjects) => {
    return arrayOfObjects.map((obj) => {
      // console.log(obj);

      const key = obj.key;

      const value = obj.value.filter((val, index, self) => {
        const status = val.status;
        return self.findIndex((obj) => obj.status === status) === index;
      });
      return {
        key,
        value,
      };
    });
  };

  // CALLING REMOVE DUPLICATES FUNCTION
  const filteredData = removeDuplicates(arrayOfData);

  // REMOVING THE EMPLOYMENT FIELD FOR THE ACEMEDEMO
  const stagesData = filteredData.filter((e) => {
    if (implId === "111") {
      if (e.key !== "Employment") {
        return e;
      }
    } else {
      return e;
    }
  });

  const clickHandler = (val) => () => {
    // console.log(val);
    // navigate(`/user/findContact/${implId}/${id}/${val}`);
  };

  const stageDataHandler = () => {
    setStageData((prev) => !prev);
  };

  const handleFetchStatusData = (stageKey) => {
    setItemsToShow((prevItems) => ({
      ...prevItems,
      [stageKey]: (prevItems[stageKey] || 0) + 10,
    }));
  };

  const getDistinctStages = (items) => {
    console.log("Input items:", items);
    const valueArray = Array.isArray(items.value) ? items.value : [];

    const stages = valueArray
        .map((item) => item.stage) 
        .filter((stage, index, self) => stage && self.indexOf(stage) === index);

        return stages.length > 0 ? stages.join(' / ') : 'NO STAGES FOUND';
  };
  
  console.log("stagessss Data", stagesData)

  return (
    <div>
      {stagesData.length !== 0 && (
        <h2
          style={{
            marginTop: "10px",
            marginLeft: "70px",
            fontSize: "24px",
            fontWeight: "bold",
          }}
        >
          <span style={{ color: "#FF762B" }}>Journey</span>{" "}
          <span style={{ color: "#00A0B2" }}>stage</span>
        </h2>
      )}
      <FormGroup>
        <FormControlLabel
          control={
            <Switch
              value={stageData}
              onClick={stageDataHandler}
              defaultChecked
            />
          }
          label="Stages with data"
        />
      </FormGroup>
      <FormGroup>
        <FormControlLabel
          control={<Switch value={show_alt_name} onClick={handlealt_name} />}
          label="Internal stages"
        />
      </FormGroup>

      <div
        className={classes.sections}
        style={{ display: "flex", justifyContent: "center" }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            flexWrap: "wrap",
            gap: "7px",
          }}
        >
          {stagesData.length !== 0 &&
            stagesData.map((data, index) => (
              <div key={index}>
                {stageData ? (
                  data.value.length !== 0 && (
                    <div className={classes.mainBox} key={index}>
                      <div className={classes.box} style={{ display: "flex" }}>
                        <div className={classes.firstArrow}></div>
                        <div className={classes.stageBox}>
                         {/*  <p>{data.key.toUpperCase()}</p> */}
                         <p>
                          {data.key && data.key !== "null"
                            ? data.key.toUpperCase()
                            : getDistinctStages(data)}
                        </p>
                        </div>
                        <div className={classes.secondArrow}></div>
                      </div>
                      <div className={classes.statusBox}>
                        <div className={classes.rectangleBox}>
                          {data.value.length !== 0 ? (
                            data.value.slice(0, itemsToShow[data.key] || 10).map((e, index) => (
                              <div key={index}>
                                <p className={classes.statusView}>
                                  <span>
                                    <CheckIcon style={{ color: "#35A2EB" }} />
                                    <span style={{ marginLeft: "4px" }}>
                                      {e.status}
                                    </span>
                                  </span>
                                  <span style={{ color: "#FF762B" }}>
                                    {new Date(e.date).toLocaleDateString()}
                                  </span>
                                </p>
                                <div className={classes.horizontalLine}></div>
                              </div>
                            ))
                          ) : (
                            <h6 style={{ fontWeight: "500", fontSize: "13px" }}>
                              No data for this stage
                            </h6>
                          )}
                        </div>
                        {data.value.length > (itemsToShow[data.key] || 10) && (
                          <button onClick={() => handleFetchStatusData(data.key)} 
                          style={{
                            marginLeft:"2.5rem",
                            border:"none",
                            backgroundColor:"#F3F8FF",
                            color:"black",
                            borderRadius:"1rem"
                        }}>Load More</button>
                        )}
                      </div>
                    </div>
                  )
                ) : (
                  <div className={classes.mainBox}>
                    <div className={classes.box} style={{ display: "flex" }}>
                      <div className={classes.firstArrow}></div>
                      <div className={classes.stageBox}>
                        {/* <p>{data.key.toUpperCase()}</p> */}
                        <p>
                          {data.key && data.key !== "null"
                            ? data.key.toUpperCase()
                            : getDistinctStages(data)}
                        </p>
                      </div>
                      <div className={classes.secondArrow}></div>
                    </div>
                    <div className={classes.statusBox}>
                      <div className={classes.rectangleBox}>
                        {data.value.length !== 0 ? (
                          data.value.slice(0, itemsToShow[data.key] || 10).map((e, index) => (
                            <div key={index}>
                              <p className={classes.statusView}>
                                <span>
                                  <CheckIcon style={{ color: "#35A2EB" }} />
                                  <span style={{ marginLeft: "4px" }}>
                                    {e.status}
                                  </span>
                                </span>
                                <span style={{ color: "#FF762B" }}>
                                  {new Date(e.date).toLocaleDateString()}
                                </span>
                              </p>
                              <div className={classes.horizontalLine}></div>
                            </div>
                          ))
                        ) : (
                          <h6 style={{ fontWeight: "500", fontSize: "13px" }}>
                            No data for this stage
                          </h6>
                        )}
                      </div>
                      {data.value.length > (itemsToShow[data.key] || 10) && (
                        <Button sx={{backgroundColor:"black"}} variant="contained" onClick={() => handleFetchStatusData(data.key)}>Load More</Button>
                      )}
                    </div>
                  </div>
                )}
              </div>
            ))}
        </div>
      </div>
    </div>
  );
};

export default Section;
